import React from 'react';
import { FormattedMessage } from 'react-intl';

// constants
import { USER_FILTER_FIELD_NAMES } from '../../../../../../constraints';

// Components
import { ControlledTextField } from '../../../../../../components/ControlledTextField';
import { FieldLabel } from '../../../../../../components/Form';

const TextLastNameField = ({ name = USER_FILTER_FIELD_NAMES.LAST_NAME }) => {
  return (
    <>
      <FieldLabel>
        <FormattedMessage id="Last name" defaultMessage="Last name" />
      </FieldLabel>
      <ControlledTextField name={name} />
    </>
  );
};

export default TextLastNameField;
